<template>
  <div>
    <el-button style="margin-bottom: 10px;" type="success" round @click="queryEmailList">同步邮件</el-button>
    <el-row :gutter="20">
      <el-col :span="4">
        <el-collapse>
          <el-collapse-item :title="`收件箱(${emailList.length})`" name="1">
            <div
              class="email-container"
              v-for="(item, index) in emailList"
              :key="index"
              @click="showEmailContent(item.content)"
            >
              <div class="email-from">{{ item.from }}</div>
              <div class="email-subject">
                {{ item.subject }}
              </div>
              <div class="email-subject">2022-11-23 14:45:35</div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-col>
      <el-col :span="20"> <div class="email-content" v-html="content"></div></el-col>
    </el-row>
  </div>
</template>

  <script>
import EmailApi from "@/api/EmailApi";
export default {
  name: "EmailUtils",
  data() {
    return {
      emailList: [],
      content: "",
    };
  },
  created() {
    this.queryEmailList();
  },
  methods: {
    queryEmailList() {
      EmailApi.emailList().then((resp) => {
        if (resp.state === "OK") {
          this.emailList = resp.data;
        }
      });
    },
    showEmailContent(content) {
      this.content = content;
    },
  },
};
</script>

<style>
.email-from {
  font-weight: bolder;
}
.email-subject {
  color: #808080;
}
.email-container {
  border-bottom: 1px solid #dadada;
  cursor:pointer;
}

.email-content{
    border:1px solid #dadada;
    padding: 10px;
    height: calc(100vh);
}
</style>